export default __webpack_public_path__ + "static/media/logo-harmon-white.81ed597c.svg";